<template lang="pug">
#password.modal.modal-bottom.fade.modal-common(tabindex='-1' role='dialog' aria-labelledby='passwordLabel' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.modal-bottom-center(role='document')
    .modal-content
      .modal-header
        .icon(data-bs-dismiss='modal' aria-label='Close')
          i.fas.fa-arrow-left
        h5.modal-title {{ $t("ui.change_account_password") }}
      .modal-body
        .setting
          .form-group.mb-0
            input.form-control(type="password" v-model="currPwd" maxlength="20" :placeholder="$t('ui.current_password')")
            small.form-text.text-danger.w-75(v-if="feedback.currPwd") {{ feedback.currPwd }}
            input.form-control.mt-2(type="password" v-model="newPwd" :placeholder="$t('ui.new_password')")
            small.form-text.text-danger.w-75(v-if="feedback.newPwd") {{ feedback.newPwd }}
            input.form-control.mt-2(type="password" v-model="confirmNewPwd" :placeholder="$t('ui.confirm_new_password')")
            small.form-text.text-danger.w-75(v-if="feedback.confirmNewPwd") {{ feedback.confirmNewPwd }}
            .text-small {{ $t("message.password_rule") }}
          .btn-wrapper.mt-2
            .btn-cancel(type="button" data-bs-dismiss='modal') {{ $t("ui.cancel") }}
            SpinButton(type="button" @click="submit" :loading="loading" css="btn-confirm" :text="$t('ui.save')")

</template>

<script>
import SpinButton from "@/components/ui/SpinButton";
import { required, sameAs, minLength, maxLength } from "vuelidate/lib/validators";
import errors from "@/errors";
import service from "@/library/_xhr-account";

export default {
  components: {
    SpinButton
  },
  data: () => ({
    loading: false,
    currPwd: "",
    newPwd: "",
    confirmNewPwd: "",
    feedback: {
      success: false,
      status: errors.request.failed,
      currPwd: "",
      newPwd: "",
      confirmNewPwd: "",
      timeout: null
    }
  }),
  validations: {
    currPwd: {
      required
    },
    newPwd: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(10)
    },
    confirmNewPwd: {
      required,
      sameAs: sameAs("newPwd")
    }
  },
  mounted() {
    $(this.$refs.password).on("hidden.bs.modal", this.onClose);
  },
  methods: {
    resetFeedback() {
      this.feedback.currPwd = "";
      this.feedback.newPwd = "";
      this.feedback.confirmNewPwd = "";
    },
    clearInput() {
      this.currPwd = "";
      this.newPwd = "";
      this.confirmNewPwd = "";
    },
    onClose() {
      this.clearInput();
      this.resetFeedback();
    },
    submit() {
      if (this.validate()) {
        this.changePassword();
      }
    },
    validate() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        return true;
      } else {
        this.loading = false;
        this.resetFeedback();
        clearTimeout(this.feedback.timeout);
        if (!this.$v.currPwd.required) {
          this.feedback.currPwd = this.$t("error.currPasswordRequired");
        }

        if (!this.$v.newPwd.required) {
          this.feedback.newPwd = this.$t("error.newPasswordRequired");
        }

        if (!this.$v.newPwd.minLength) {
          this.feedback.newPwd = this.$t("error.isMinValue", {"fname": this.$t("ui.new_password"), "fvalue":"6"});
        }

        if (!this.$v.newPwd.maxLength) {
          this.feedback.newPwd = this.$t("error.isMaxValue", {"fname": this.$t("ui.new_password"), "fvalue":"10"});
        }

        if (!this.$v.confirmNewPwd.required) {
          this.feedback.confirmNewPwd = this.$t("error.confirmNewPasswordRequired");
        }

        if (!this.$v.confirmNewPwd.sameAs) {
          this.feedback.confirmNewPwd = this.$t("error.passwordsNotMatch");
        }

        this.feedback.timeout = setTimeout(() => {
          this.$v.$reset();
          this.resetFeedback();
        }, 10000);
      }

      return false;
    },
    changePassword() {
      this.resetFeedback();

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        password: this.currPwd,
        new_password: this.newPwd
      };

      this.loading = true;
      service.changePassword(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.clearInput();
              this.$helpers.showDialog(this.$t("ui.change_account_password"), this.$t("message.change_password_succeed"), "success");
              $('#password').modal('hide');
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          
          if (err.status == "invalid_password") {
            this.feedback.currPwd = this.$t("error.invalid_password");
          } else {
            this.$helpers.handleFeedback(err.status);
          }
        }
      );
    }
  }
}
</script>